import { useMemo } from 'react';
import dayjs from 'dayjs';
import { pad2, minutesOf, snapToStep } from '../TimeStepper';

export const DAY_MAX = 23 * 60 + 55;

export const totalToHHmm = (total) =>
  `${pad2(Math.floor(total / 60))}:${pad2(total % 60)}`;

export const parseHHmmToTotal = (raw) => {
  if (!raw || typeof raw !== 'string') return null;
  const [hoursRaw, minutesRaw] = raw.split(':');
  const hours = parseInt(hoursRaw, 10);
  const minutes = parseInt(minutesRaw, 10);
  if (Number.isNaN(hours) || Number.isNaN(minutes)) return null;
  return hours * 60 + minutes;
};

export const useTimePickerBounds = (value, minTime, maxTime, timeStep = 5) => {
  const step = timeStep || 5;

  const safeValue = useMemo(() => {
    if (value?.isValid?.()) return value;
    if (value) {
      const parsed = dayjs(value);
      if (parsed.isValid()) return parsed;
    }
    return dayjs().hour(9).minute(0).second(0).millisecond(0);
  }, [value]);

  const minTotal = minTime ? minutesOf(minTime) : 0;
  const maxTotal = maxTime ? minutesOf(maxTime) : DAY_MAX;

  const boundOpts = useMemo(
    () => ({
      min: Math.ceil(minTotal / step) * step,
      max: Math.floor(maxTotal / step) * step,
    }),
    [minTotal, maxTotal, step],
  );

  const currentTotal = snapToStep(minutesOf(safeValue), step);
  const display = totalToHHmm(currentTotal);

  const minInput = minTime ? totalToHHmm(boundOpts.min) : undefined;
  const maxInput = maxTime ? totalToHHmm(boundOpts.max) : undefined;

  return {
    step,
    safeValue,
    boundOpts,
    currentTotal,
    display,
    minInput,
    maxInput,
  };
};
